import { Glue42Office } from "../../glue4office";
import { CloseMethodName, ReceiveHtmlMethodName } from "./const";
import { InternalOpenDocumentConfig } from "./types";

export function mapOptions(data: Glue42Office.Word.OpenDocumentConfig): InternalOpenDocumentConfig {
    const mappedOptions: InternalOpenDocumentConfig = {
        displayName: "", // data.name,
        documentName: data.name,
        templateName: data.templateName,
        onSaved: ReceiveHtmlMethodName,
        onClosed:  CloseMethodName,
    };
    return mappedOptions;
}
